import type { StateCreator } from 'zustand';
import type { PrescriptionAssistantSliceType } from '../types';

export const updatePrescriptionHistoryItemsToAction: StateCreator<
  PrescriptionAssistantSliceType,
  [['zustand/immer', never], ['zustand/devtools', never]],
  [],
  (itemsToAction: number[]) => void
> = (set) => (itemsToAction) =>
  set(
    (state: PrescriptionAssistantSliceType) => {
      state.prescriptionAssistant.prescriptionHistory.itemsToAction = itemsToAction;
    },
    false,
    'prescriptionHistory/updatePrescriptionHistoryItemsToAction'
  );
